const rebuyActions = {
    init: () => {
        if (!document.querySelector(".rebuy-addon")) {
            let attempts = 0;
            const maxAttempts = 10;
            const interval = setInterval(() => {
                attempts++;
                if (document.querySelector(".rebuy-addon")) {
                    clearInterval(interval);
                    rebuyActions.events();
                } else if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 500);

            return;
        } else {
            rebuyActions.events();
        }
    },

    events: () => {
        document
            .querySelectorAll(".rebuy-checkbox")
            .forEach(function (checkbox) {
                checkbox.addEventListener("change", function () {
                    rebuyActions.checkTotal();
                });
            });

        document.querySelectorAll(".rebuy-select").forEach(function (select) {
            select.addEventListener("change", function () {
                rebuyActions.checkTotal();
            });
        });

        document
            .querySelector('product-form input[name="quantity"]')
            ?.addEventListener("change", function () {
                rebuyActions.checkTotal();
            });
    },

    checkTotal: () => {
        let total = 0;
        const subtotalEl = document.querySelector(
            ".rebuy-addon__subtotal-value .rebuy-money",
        );
        if (subtotalEl) {
            const subtotalText = subtotalEl.textContent.trim();
            const subtotalValue = parseFloat(
                subtotalText.replace(/[^0-9.-]+/g, ""),
            );
            if (!isNaN(subtotalValue)) {
                total += subtotalValue;
            }
        }

        total = total * 100;

        const qty =
            parseInt(
                document.querySelector(
                    'product-form input[name="quantity"]',
                )?.value,
            ) || 0;
        const unitPrice =
            parseFloat(
                document.querySelector("product-form .buy-bar-total")
                    ?.dataset.unitPrice,
            ) || 0;

        total += qty * unitPrice;

        const totalElements = document.querySelectorAll(
            "product-form .buy-bar-total",
        );
        totalElements.forEach((totalEl) => {
            const formattedTotal = (total / 100).toLocaleString(
                window.rebuyActions.locale || "en-GB",
                {
                    style: "currency",
                    currency: window.rebuyActions.currency || "GBP",
                },
            );
            totalEl.textContent = formattedTotal;
            totalEl.setAttribute(
                "aria-label",
                `Total price: ${formattedTotal}`,
            );
        });
    },
};

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        rebuyActions.init();
    }, 500);
});
